import { Serializable } from './Serializable';

export class PollResponseDTO extends Serializable {

    questionID: string;
    name: string;
    description: string;
    isSupportsFeedback: boolean;
    type: number;
    titlePositiveFeedback: string;
    titleNegativeFeedback: string;

    imageOne: string;
    imageTwo: string;

    constructor() {
        super();
    }

}
